import { Inject, Injectable } from "@angular/core";
import { IAggregateActionHandler, AggregateHelperService, ActionReturn, AggregateActionResult, isCardAction, } from "@tylertech/aggregates-module";
import { IAggregate, ICardData, ICardAction, ActionType } from "@tylertech/tyler-api-types";

import { PacketDialogsService } from "../services/packetDialogService";

@Injectable()
export class PacketActionHandler implements IAggregateActionHandler
{
    constructor(
        private $aggregateHelperService: AggregateHelperService,
        private $packetDialogService: PacketDialogsService,
    ) { }

    predicate(_aggregate: IAggregate, _cardData: ICardData, action: ICardAction): boolean
    {
        return action.actionType === ActionType.Packet;
    }

    execute(aggregate: IAggregate, cardData: ICardData, _action: ICardAction): Promise<AggregateActionResult>
    {
        const packetId = this.$aggregateHelperService.getFieldValue(cardData, "PacketId");
        const packetType = this.$aggregateHelperService.getFieldValue(cardData, "ProcessType");
        const alternateType = this.$aggregateHelperService.getFieldValue(cardData, "AlternateType");
        const passedActions = cardData.CardActions.filter(v => v.actionType !== ActionType.Packet);

        return this.$packetDialogService.show(
            packetId, aggregate.AggregateProviderId, packetType, cardData.SubHeader, passedActions, alternateType)
            .then(
                (action: ICardAction | undefined) =>
                {
                    return action
                        ? this.$aggregateHelperService.performServerCardAction(aggregate, cardData, action)
                            .then(() =>
                            {
                                return <ActionReturn>{
                                    action: action,
                                    success: true,
                                };
                            })
                        : false;
                });
    }

    load(_aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): void
    {
        /* NO_OP */
    }
}
